GP.views.ContentTrendingItem = Backbone.Marionette.ItemView.extend({
    initialize:function() {

    },
    template: function(serialized_data) {
        if (serialized_data.content.is_premium) {
            return template('content-trending-premium-item', serialized_data);
        } else if (serialized_data.content.is_camsoda == 'Y') {
            return template('content-trending-item-camsoda', serialized_data);
        } else if (serialized_data.content.is_post_placeholder == 'Y') {
            return template('content-trending-item-post', serialized_data);
        } else {
            return template('content-trending-item', serialized_data);
        }
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            content: this.model.toJSON()
        };

        data.content.like_count = parseInt(data.content.like_count,10);
        data.content.like_count_k = GP.Util.k_formatter(data.content.like_count);
        data.content.comment_count = parseInt(data.content.comment_count,10);
        data.content.comment_count_k = GP.Util.k_formatter(data.content.comment_count);

        if (data.content.content_type == 'story') {
            data.content.story = GP.Util.format_story(data.content.story, 200);
        }
        if (data.content.is_post_placeholder == 'Y') {
            data.content.auth_pic = GP.sdata.my_user.pic.replace('-S.jpg', '-M.jpg');
        }
        return data;
    },
    className: 'trending-item',
    tagName: 'div',
    attributes: function() {
        var self = this;
        return {

        };
    },
    templateHelpers: function() {
        var self = this;

        return {
            modal_url: function() {
                let url_opts = {
                    duid: this.content.duid,
                    content_id: this.content.content_id
                };

                if (this.content.blurred_preview) {
                    url_opts.prv = 1;
                }

                var _modal_url = GP.Util.clean_url('/members/content/viewer/', url_opts);
                return _modal_url;
            },
            like_text_plural: function() {
                return (this.content.like_count > 1);
            },
            comment_text_plural: function() {
                return (this.content.comment_count > 1);
            },
            show_likes: function() {
                if (this.content.content_type == 'text') {
                    return false;
                }
                return (this.content.like_count > 0 || this.content.is_camsoda != 'Y');
            },
            show_comments: function() {
                return (this.content.comment_count > 0);
            },
            show_content_text: function() {
                return (!_.isEmpty(this.content.caption) || this.content.content_type == 'text');
            },
            is_content_caption: function() {
                return !_.isEmpty(this.content.caption);
            },
            content_type_text: function() {
                return (this.content.content_type == 'text');
            },
            content_type_media: function() {
                return (this.content.content_type == 'media');
            },
            content_type_story: function() {
                return (this.content.content_type == 'story');
            },
            content_type_image: function() {
                return (this.content.type == 'IMAGE');
            },
            content_type_video: function() {
                return (this.content.type == 'VIDEO');
            },
            safemode_chk: function() {
                var safe_mode = GP.sdata.my_user.pg;

                //tmp until ready
                return false;

                /*if (safe_mode && this.content.rating == 'R') {
                    return true;
                }

                return false;*/
            },
            show_max_content_notice: function() {
                var max_content_rating = GP.sdata.my_user.max_content_rating.toUpperCase();

                if (max_content_rating == 'PG' && this.content.rating !== 'PG') {
                    return true;
                }

                if (max_content_rating == 'R' && this.content.rating == 'X') {
                    return true;
                }

                return false;
            },
            show_likes_comments: function() {
                return (this.content.like_count > 0 || this.content.comment_count > 0);
            },
            content_diamond_url: function() {
                if (window._full_domain_name.match(/wealthymen\.com/i)) {
                    return cdn_domain + '/images/diamond_wealthymen.com.png';
                }

                if (window._full_domain_name.match(/richmen\.com/i)) {
                    return cdn_domain + '/images/diamond_richmen.com.png';
                }
            },
            content_diamond_income: function() {
                if (window._full_domain_name.match(/wealthymen\.com/i) || window._full_domain_name.match(/richmen\.com/i)) {
                    if (this.content.income) {
                        if (this.content.income.match(/150/)) {
                            return true;
                        }
                    }
                }

                return false;
            },
            content_weed_interest: function() {
                if (window._full_domain_name.match(/smokeandpoke\.com/i)) {
                    if (this.content.interests) {
                        return this.content.interests.match(/WEED/);
                    }
                }

                return false;
            },
            content_games_interest: function() {
                if (window._full_domain_name.match(/sexygamerz\.com/i)) {
                    if (this.content.interests) {
                        return this.content.interests.match(/GAMES/);
                    }
                }

                return false;
            },
            isWoman: function() {
                return (this.content.gender == 'F');
            },
            isMan: function() {
                return (this.content.gender == 'M');
            },
            isVerifiedPic: function() {
                return (this.content.verified_pic);
            },
            is_camsoda: function() {
                return (this.content.is_camsoda == 'Y');
            },
            has_mood_status: function() {
                return (this.content.content_type == 'media' && this.content.mood_status);
            },
            mood_status_chatting: function() {
                return (this.content.content_type == 'media' && this.content.mood_status_id === 1);
            },
            mood_status_meetup: function() {
                return (this.content.content_type == 'media' && this.content.mood_status_id === 2);
            },
            mood_status_relationship: function() {
                return (this.content.content_type == 'media' && this.content.mood_status_id === 3);
            },
            mood_status_vchat: function() {
                return (this.content.content_type == 'media' && this.content.mood_status_id === 4);
            },
            has_premium_content: function() {
                let has_premium_content = (typeof this.content.premium_public_content_count !== 'undefined');
                return (has_premium_content && !GP.sdata.my_user.native_app_reg);
            },
            is_blur: function() {
                let is_blur_url = false;

                // don't show unlock button for free previews.
                if (this.content.blurred_preview) {
                    return false;
                }

                if (this.content.content_type == 'media' && this.content.url.match(/cacheb/i)) {
                    is_blur_url = true;
                } else if (this.content.type == 'VIDEO' && this.content.video_thumb_url.match(/cacheb/i)) {
                    is_blur_url = true;
                }

                return (GP.sdata.my_user.membership === 'FREE' && is_blur_url);
            },
            is_free_preview: function() {
                return this.content.blurred_preview;
            },
            show_locked_icon: function() {
                return (GP.sdata.my_user.membership === 'BRONZE' && this.content.blurred && this.content.type !== 'VIDEO');
            }
        };
    },
    ui: {
        trending_content: '.content-main',
        btn_desktop_like: '.btn-desktop-like',
        like_count_wrap: '.like-count-wrap ',
        verified_tooltip: '.verified-tooltip',
        btn_trending_item_post: '.js-trending-item-post'
    },
    events: {
        'click @ui.btn_desktop_like': 'content_like',
        'click @ui.like_count_wrap': 'content_like',
        'click @ui.btn_trending_item_post': 'item_post',
        // 'click @ui.verified_tooltip': 'toggle_verified_tooltip',
        // 'mouseenter @ui.verified_tooltip': 'toggle_verified_tooltip',
    },
    modelEvents: {
        'change:like_count': 'render',
        'change:comment_count': 'render',
        'change:animate_heart': 'animate_heart',
        'change:url': 'render',
        'change:video_thumb_url': 'render',
        'change:pic': 'render',
        'change:blurred': 'render',
    },
    onShow: function() {
        GP.vent.trigger('User:setup_verified_tooltip',  this.$el.find('.verified-tooltip'));
    },
    onRender: function() {
        // Format and display timestamp
        jQuery.timeago.settings.strings =  GP.Util.configs.timeago;
        this.$el.find('.timeago').timeago();

        if (!this.model.get('is_premium')) {
            this.content_click();
        }
    },
    chk_like_btn: function(e) {
        let $clicked = $(e.target);
        let like_btn = 'button.btn-content-like';

        // bail on opening the content viewer if the like button was clicked
        if ($clicked.is(like_btn) || $clicked.parent().is(like_btn)) {
            return true;
        }

        return false;
    },
    content_click: function(e) {
        var self = this;
        var modal_link = this.$el.find('.modal-link');
        let unlock_params = {
            content_id: this.model.get('content_id'),
            clicked_model: this.model,
        };

        if (GP.Util.check_ios()) {
            var timeout_tap = null;
            modal_link.on('tap', function(e) {
                if (self.chk_like_btn(e)) {
                    return;
                }

                if (!timeout_tap) {
                    timeout_tap = setTimeout(function(){
                        timeout_tap = null;

                        if (self.check_bronze_blur()) {
                            GP.vent.trigger('Unlock:show_unlock_modal', self.model.get('duid'), unlock_params);
                        } else {
                            self.show_content_viewer();
                        }
                    }, 250);
                } else {
                    clearTimeout(timeout_tap);
                    timeout_tap = null;
                    self.increment_likes();
                }
                e.stopImmediatePropagation();
                return false;
            });
        } else {
            var timeout_click = null;
            modal_link.on('click', function(e) {
                if (self.chk_like_btn(e)) {
                    return;
                }

                if (!timeout_click) {
                    timeout_click = setTimeout(function(){
                        timeout_click = null;

                        if (self.check_bronze_blur()) {
                            GP.vent.trigger('Unlock:show_unlock_modal', self.model.get('duid'), unlock_params);
                        } else {
                            self.show_content_viewer();
                        }
                    }, 250);
                } else {
                    clearTimeout(timeout_click);
                    timeout_click = null;
                    self.increment_likes();
                }
                e.stopImmediatePropagation();
                return false;
            });
        }
    },
    check_bronze_blur: function() {
        if (GP.sdata.my_user.membership === 'BRONZE') {
            if (this.model.get('type') == 'IMAGE' && this.model.get('url').match(/cacheb/i)) {
                return true;
            } else if (this.model.get('type') == 'VIDEO' && this.model.get('video_thumb_url').match(/cacheb/i)) {
                return true;
            }
        }

        return false;
    },
    content_like: function(e) {
        if (this.model.get('is_liked')) {
            GP.vent.trigger('Content:decrement_likes',  this.model);
        } else {
            GP.vent.trigger('Content:increment_likes',  this.model);
        }
    },
    decrement_likes: function() {
        GP.vent.trigger('Content:decrement_likes',  this.model);
    },
    increment_likes: function() {
        if (!this.model.get('is_liked')) {
            GP.vent.trigger('Content:increment_likes',  this.model);
        } else {
            // animate heart again just for feedback
            GP.vent.trigger('Content:animate_heart',  this.$el.find('.like-animate'));
        }
    },
    show_content_viewer: function() {
        let url_opts = {
            duid: this.model.get('duid'),
            content_id: this.model.get('content_id'),
        };

        if (typeof this.model.get('blurred_preview') !== 'undefined' && this.model.get('blurred_preview')) {
            url_opts.prv = 1;
        }

        if (_.contains(this.model.get('tags'), 'VIDEO_INTRO')) {
            url_opts.video_intro = 1;
        }

        var modal_url = GP.Util.clean_url('/members/content/viewer/', url_opts);

        GP.vent.trigger('Modal:open', {
            url: modal_url,
            spinner: true,
        }, this.$el.find('.modal-link'));
    },
    animate_heart: function() {
        if (this.model.get('animate_heart')) {
            GP.vent.trigger('Content:animate_heart',  this.$el.find('.like-animate'));
        }
    },
    toggle_verified_tooltip: function() {
        GP.vent.trigger('User:toggle_verified_tooltip',  this.$el.find('.verified-tooltip'));
    },
    item_post: function() {
        GP.vent.trigger('Modal:open', {url: '/members/user/upload_pic/'});
    }
});

GP.views.CompositeView = Backbone.Marionette.CompositeView.extend({
    initialize:function() {
        var current_url = (window.location.pathname + window.location.search).toLowerCase();
        this.is_home = current_url.indexOf('home') !== -1;
        this.trending_region = $('#trending-region');
    },
    template: function(serialized_data) {
        if (serialized_data.no_results) {
            return template('content-trending-no-results', serialized_data);
        } else {
            return template('content-trending-view', serialized_data);
        }
    },
    serializeData: function() {
        return {
            no_results: (this.collection.length === 0),
        };
    },
    className: 'feed-main',
    childView: GP.views.ContentTrendingItem,
    ui: {
        btn_trending_safemode_off: '.btn-trending-safemode-off'
    },
    events: {
        'click @ui.btn_trending_safemode_off': 'safemode',
    },
    onShow: function() {
        // Hide spinner
        if (this.is_home) {
            GP.vent.trigger('ContentHome:hide_spinner');
        } else {
            GP.vent.trigger('ContentTrending:hide_spinner');
        }
    },
    onRender: function() {

    },
    safemode: function() {
        var _url = GP.Util.clean_url('/members/content/trending/', {
            filter_type: GP.ContentTrending.filter_type
        });
        GP.vent.trigger('User:safemode', 'off', _url);
    }
});





